export const DRIVER_LICENSES_TYPES = {
  A: '6e763394-5c79-4c51-9f21-fa52bab10ead',
  B: '20a935f3-942f-4ab9-90c0-ff4828afb0a4',
  C: '3cd0119d-faaf-4eda-bdec-75470f434192',
  D: '76d5887e-0f9a-469c-a422-3982770e73a4',
  E: '41fde5bd-bed2-4532-b83e-d41db43f798b',
  F: '654dc106-9100-401b-89cb-f14ccac7faed',
};
